/**
 * A challenge's due_date ("2026-11-01") -> "November 1, 2026 at 11:59pm".
 * Parses the date parts directly so no time zone conversion can shift it by
 * a day. Returns null when there is no due date.
 */
export const formatDeadline = (ymd) => {
  if (!ymd) return null;
  const [y, m, d] = String(ymd).slice(0, 10).split("-").map(Number);
  const date = new Date(y, m - 1, d).toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
  return `${date} at 11:59pm`;
};
